// extracted by mini-css-extract-plugin
export default {"container":"ContactUsSuccess_container__ubXCm","row":"ContactUsSuccess_row__QIPUz","h1":"ContactUsSuccess_h1__cf4U4","h2":"ContactUsSuccess_h2__mseNN"};